/**
 * StatRow — the row of headline numbers at the top of each eval screen.
 */

import { cn } from '@/lib/utils'
import { Card, CardContent } from '@/components/ui/card'

export interface Stat {
  label: string
  value: string
  detail?: React.ReactNode
}

// Columns track the stat count so the row always fills to the gutter — 4
// stats on the overview, 5 on the task page. Both class strings are literal
// so Tailwind keeps them.
export function StatRow({ stats }: { stats: Stat[] }): React.JSX.Element {
  const cols = stats.length >= 5 ? 'lg:grid-cols-5' : 'lg:grid-cols-4'
  return (
    <div className={cn('grid gap-3 sm:grid-cols-2', cols)}>
      {stats.map((stat) => (
        <Card key={stat.label}>
          <CardContent className="p-4">
            <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground">
              {stat.label}
            </p>
            <div className="mt-1 flex items-baseline gap-2">
              <span className="whitespace-nowrap font-mono text-lg tabular-nums text-foreground">
                {stat.value}
              </span>
              {stat.detail}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
